import { createListenerMiddleware } from '@myua/rtk-helper';
//todo: move to general
import { figmaImportRootListener } from '../creativeHub/modules/figmaImport/logic';
import { ListenerApiSafe } from '../general/listenerMiddlewareAddons';
import { RootStore } from './reducers';
import { figmaImportNotifListeners } from './modules/figmaImportNotif/listeners';
import { appListeners } from './modules/app/listeners';
import { assetLinkListeners } from './modules/assetLink/listeners';
import { categoryRootListeners } from './modules/category/listeners';
import { extensionListeners } from './modules/extension/listeners';
import { favoriteListeners } from './modules/favorite/listeners';
import { finderListeners } from './modules/finder/listeners';
import { lastStateListeners } from './modules/lastState/listeners';
import { packListeners } from './modules/pack/listeners';
import { projectListeners } from './modules/project/listeners';
import { searchListeners } from './modules/search/listeners';
import { sharingListeners } from './modules/sharing/listeners';
import { sharingLinkListeners } from './modules/sharingLink/listeners';
import { sortingListeners } from './modules/sorting/listeners';
import { tagListeners } from './modules/tag/listeners';
import { tagBinderListeners } from './modules/tagBinder/listeners';
import { viewerListeners } from './modules/viewer/listeners';
import { viewModeListeners } from './modules/viewMode/listeners';
import { fullscreenPreviewListeners } from './modules/fullscreenPreview/listeners';
import { commentListeners } from './modules/comment/listeners';
import { deepLinkListeners } from './modules/deepLink/listeners';
import { demoWelcomeListeners } from './modules/demoWelcome/listeners';
import { googleBulkListeners } from './modules/googleBulk/listeners';
import { previewListeners } from './modules/preview/listeners';
import { magicStudioListeners } from './modules/magicStudio/listeners';
import { filtersCacheListeners } from './modules/filtersCache/listeners';

export { _fork, _select, _take } from '../general/listenerMiddlewareAddons';
export type ListenerApi = ListenerApiSafe<RootStore>;
export const lm = createListenerMiddleware<RootStore>();
export const { takeEvery, takeLatest, takeLatestById, takeOnce } = lm;

export function rootListeners() {
  appListeners();
  assetLinkListeners();
  categoryRootListeners();
  extensionListeners();
  favoriteListeners();
  figmaImportRootListener(lm);
  figmaImportNotifListeners();
  filtersCacheListeners();
  finderListeners();
  fullscreenPreviewListeners();
  lastStateListeners();
  packListeners();
  projectListeners();
  searchListeners();
  sharingListeners();
  sharingLinkListeners();
  sortingListeners();
  tagListeners();
  tagBinderListeners();
  viewerListeners();
  viewModeListeners();
  commentListeners();
  deepLinkListeners();
  demoWelcomeListeners();
  googleBulkListeners();
  previewListeners();
  magicStudioListeners();
}
